module.exports = __webpack_public_path__ + "static/img/icon_cloud_p3.5062373.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/cloud/images/icon_cloud_p3.jpg
// module id = JdZf
// module chunks = 21